// Environment variables with fallbacks
const config = {
    // API Configuration
    api: {
        // Use production URLs by default, override with .env for local development
        baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://vapi.jeremyslab.dev',
        version: process.env.REACT_APP_API_VERSION || '/api',
        timeout: process.env.REACT_APP_API_TIMEOUT || 30000,
        rootUrl: process.env.REACT_APP_API_URL || 'https://vapi.jeremyslab.dev',
        authUrl: process.env.REACT_APP_AUTH_BASE_URL || 'https://vapi.jeremyslab.dev/api/auth',
        messageHubUrl: process.env.REACT_APP_MESSAGE_HUB_URL || 'https://vapi.jeremyslab.dev/messageHub',
        
        // Utility functions for URL construction
        get url() {
            return `${this.baseUrl}${this.version}`;
        },
        getEndpointUrl(endpoint) {
            return `${this.url}${endpoint}`;
        },
        getAuthEndpointUrl(endpoint) {
            return `${this.authUrl}${endpoint}`;
        }
    },
    
    // Environment
    env: process.env.REACT_APP_ENV || 'development',
    
    // Application settings
    app: {
        version: '1.0.0',
        dateFormat: 'MMMM dd, yyyy',
        timeFormat: 'h:mm a'
    },
    
    // Feature flags
    features: {
        enableDebugLogging: process.env.REACT_APP_ENABLE_DEBUG_LOGGING === 'true' || false
    }
};

export default config; 